'use strict';
angular.module('TurneroApp').component('coConfirmacionOnline', {
    bindings: {
        turnoDetalle: '<'
    },
    controller: [
        '$window',
        'turnosService',
        '$state',
        '$rootScope',
        '$scope',
        'TurneroAppConstant',
        'utilsService',
        '$localStorage',
        '$mdDialog',
        '$q',
        function ($window, turnosService, $state, $rootScope, $scope, TurneroAppConstant, utilsService, $localStorage, $mdDialog, $q) {
            var ctrl = this;
            ctrl.Turno = null
            ctrl.layoutState = $state.$current.name.split('.')[0];
            ctrl.ConfirmandoTurno = false;
            ctrl.limpiarMemoria = function () {
                $rootScope.$broadcast('esCalendario', false);
                $rootScope.$broadcast('esHome', false);
                $rootScope.$broadcast('esTasaRetributiva', false);
                ctrl.Turno = $rootScope.TurnoDetalle;
                if (ctrl.Turno == null) {
                    $state.go('ciudadano.home');
                }
            }

            function esPatenteValida(patente) {
            const formatoViejo = /^[A-Z]{3}\s\d{3}$/;          // ABC 123
            const formatoNuevo = /^[A-Z]{2}\s\d{3}\s[A-Z]{2}$/; // AB 123 CD

            return formatoViejo.test(patente) || formatoNuevo.test(patente);
        }

            //LOADING BLOCK (SOLO COPIAR)
            ctrl.loading = true;
            ctrl.ajaxArray = [];
            ctrl.d1 = $q.defer();
            ctrl.d2 = $q.defer();
            ctrl.d3 = $q.defer();

            ctrl.ajaxArray.push(ctrl.d1.promise)
            ctrl.ajaxArray.push(ctrl.d2.promise)
            ctrl.ajaxArray.push(ctrl.d3.promise)

            $q.all(ctrl.ajaxArray).then(function () {
                ctrl.loading = false;
            });
            //---------------------------

            ctrl.$onInit = function () {
                ctrl.limpiarMemoria();
                ctrl.getConfirmacionesDocumentos();
                ctrl.mostrarErrorPatente = false;
                ctrl.mensajeErrorPatente = '';
            };

            ctrl.cancelar = function () {
                $rootScope.TurnoDetalle = null;
                //ctrl.limpiarTasas();
                $state.go(ctrl.layoutState + '.calendario');
            }

            $scope.$on('confirmarTurno', function (event, datos) {
                ctrl.Turno = datos;

                $rootScope.TurnoDetalle = null;
                ctrl.getConfirmacionesDocumentos();
            });

            ctrl.GenerarTasas = function () {
                //dump function
                return true;
            }


            ctrl.getConfirmacionesDocumentos = function () {
                if (ctrl.Turno != null) {
                    utilsService.swalNotification('Un momento...', 'Obteniendo datos...', 'info');
                    turnosService.Get_PreConfirmacion_Online({ 'filtro.Id_Agenda': ctrl.Turno.Centro.agenda_Seleccionada.id, 'filtro.Id_Tramite_Relevado': ctrl.Turno.Tramite.Id_Tramite_Relevado }).$promise.then(function (resultado) {
                        ctrl.d1.resolve();
                        ctrl.Id_Tramite_Aplicacion = resultado.Data.Id_Tramite_Aplicacion
                        ctrl.preConfirmacion = resultado.Data;

                        ctrl.Turno.Centro = {
                            Domicilio: ctrl.preConfirmacion.Domicilio,
                            N_Centro_Atencion: ctrl.preConfirmacion.N_Centro_Atencion,
                            agenda_Seleccionada: ctrl.Turno.Centro.agenda_Seleccionada
                        }

                        ctrl.documentacionTramite = resultado.Data.Tramite;
                        ctrl.Turno.Notifica = {
                            Mail: 'S',
                            Telefono: 'S'
                        }
                        ctrl.mostrarCampos = {
                            Datos_Adicionales: resultado.Data.Permite_Datos_Adicionales == 'S',
                            Observaciones: resultado.Data.Permite_Observaciones == 'S',
                            Solicita_Patente_Dominio: resultado.Data.Solicita_Patente_Dominio == 'S'
                        }
                        swal.close();
                    }).catch(function (error) {
                        ctrl.d1.resolve();
                        swal.close();
                        utilsService.errores(error);
                    });
                }
            }

            ctrl.onClickAceptar = function () {
                ctrl.ConfirmandoTurno = true;
                ctrl.mostrarErrorPatente = false;
                ctrl.mensajeErrorPatente = '';

                if (ctrl.mostrarCampos.Solicita_Patente_Dominio) {

                    const patenteNormalizada = utilsService.normalizarPatente(ctrl.Turno.Patente_Dominio);

                    if (!patenteNormalizada) {
                        ctrl.mostrarErrorPatente = true;
                        ctrl.mensajeErrorPatente = 'Campo obligatorio';
                        ctrl.ConfirmandoTurno = false;
                        return;
            }

                    if (!esPatenteValida(patenteNormalizada)) {
                        ctrl.mostrarErrorPatente = true;
                        ctrl.mensajeErrorPatente = 'Formato de patente inválido. Ej: ABC 123 o AB 123 CD';
                        ctrl.ConfirmandoTurno = false;
                        return;
                }

                // guardo la patente ya prolija
                ctrl.Turno.Patente_Dominio = patenteNormalizada;
    }   
                //request
                if (ctrl.Id_Tramite_Aplicacion && (ctrl.appExterna && ctrl.appExterna.Columnas.length > 0))
                    ctrl.ConfirmacionAppExterna();
                else
                    ctrl.GuardarTurno();
            }

            ctrl.GuardarTurno = function () {
                utilsService.swalNotification('Un momento...', 'Reservando Turno...', 'info');
                if (ctrl.GenerarTasas()) {
                    var Turno = {
                        //03/06/2019 Se va a enviar en formato simil ISO pero SIN Timezone
                        //Fec_Turno_string: (ctrl.Turno.Datos.dia.getDate().toString() + '/' + (ctrl.Turno.Datos.dia.getMonth() + 1).toString() + '/' + ctrl.Turno.Datos.dia.getFullYear().toString() + ' ' + ctrl.Turno.Datos.hora),
                        Fec_Turno: ctrl.Turno.Datos.dia.getFullYear() + '-' + (ctrl.Turno.Datos.dia.getMonth() + 1) + '-' + ctrl.Turno.Datos.dia.getDate() + 'T' + ctrl.Turno.Datos.hora,
                        Id_Tramite_Relevado: ctrl.Turno.Tramite.Id_Tramite_Relevado,
                        Id_Modalidad: TurneroAppConstant.Modalidades.OnLine,
                        Datos_Adicionales: ctrl.Turno.Datos_Adicionales != null && ctrl.Turno.Datos_Adicionales != undefined ? ctrl.Turno.Datos_Adicionales : '',
                        Observaciones: ctrl.Turno.Observaciones != null && ctrl.Turno.Observaciones != undefined ? ctrl.Turno.Observaciones : '',
                        Notificar_Sms: ctrl.Turno.Notifica.Telefono,
                        Notificar_Email: ctrl.Turno.Notifica.Mail,
                        Nro_Ticket: '',
                        Sujeto_Ley_9131: '',
                        Id_Agenda: parseInt(ctrl.Turno.Centro.agenda_Seleccionada.id),
                        //Id_Prioridad: '', //15/04/2019 Si se envía como un empty string donde corresponde un int el backend lo rechaza en .NET Core
                        Id_Tramite_Suac: '',
                        //16/04/2019 Estaba mal hecho, ya que usar la variable interna "_i" lo único que hace es devolver el valor string de entrada, el cual NO corresponde al formato ISO_8601
                        //Fec_Solicitado: moment(ctrl.Turno.Datos.dia.getDate() + '/' + (ctrl.Turno.Datos.dia.getMonth() + 1) + '/' + ctrl.Turno.Datos.dia.getFullYear() + 'T' + ctrl.Turno.Datos.hora, moment.ISO_8601)._i,
                        //03/06/2019 SE COMPROBÓ QUE NO LO USA EL BACKEND
                        //Fec_Solicitado: ctrl.Turno.Datos.dia.getFullYear() + '/' + (ctrl.Turno.Datos.dia.getMonth() + 1) + '/' + ctrl.Turno.Datos.dia.getDate() + 'T' + ctrl.Turno.Datos.hora,
                        //Fec_Solicitado: '2019-06-13T14:00',//ctrl.Turno.Datos.dia.toISOString(),
                        I_AppExterna: ctrl.input_App_Externa ? ctrl.input_App_Externa : null,
                        Tasas: ctrl.input_Tasas_Tramite ? ctrl.input_Tasas_Tramite : null,
                        Patente_Dominio: (ctrl.Turno.Patente_Dominio != null && ctrl.Turno.Patente_Dominio !== undefined) ? ctrl.Turno.Patente_Dominio.trim() : ''
                    };

                    turnosService.Post_Turno_Online(Turno).$promise.then(function (resultado) {
                        swal.close();
                        var turnoDetalle = {
                            N_Tramite: ctrl.Turno.Tramite.N_Tramite,
                            N_Centro_Atencion: ctrl.Turno.Centro.N_Centro_Atencion,
                            Fec_Turno: ctrl.Turno.Datos.dia.getDate() + '/' + (ctrl.Turno.Datos.dia.getMonth() + 1) + '/' + ctrl.Turno.Datos.dia.getFullYear(),
                            Hora_Desde: ctrl.Turno.Datos.hora,
                            Domicilio: ctrl.Turno.Centro.Domicilio,
                            Id_Turno: resultado.Data.Id_Turno,
                            Mensaje_Respuesta: resultado.Data.Mensaje
                        }
                        ctrl.reimprimirTurno(turnoDetalle);
                    }).catch(function (error) {
                        swal.close();
                        utilsService.errores(error);
                    }).finally(() => ctrl.ConfirmandoTurno = false);
                } else {
                    ctrl.ConfirmandoTurno = false;
                    sweetAlert("Faltan completar datos", 'Se deben completar todos los datos de tasas retributivas.', "warning");
                }
            }

            ctrl.reimprimirTurno = function (turno) {
                ctrl.turnoSeleccionado = turno;
                ctrl.turnoSeleccionado.usuario = {
                    nombre: $localStorage.TurneroApp_Authorization.usuario.nombre,
                    CUIT: utilsService.CUIL_Formateado($localStorage.TurneroApp_Authorization.usuario.CUIL)
                };
                $mdDialog.show({
                    template: require('./modalComprobante.html'),
                    parent: angular.element(document.body),
                    clickOutsideToClose: false,
                    fullscreen: false, // Only for -xs, -sm breakpoints.,
                    controllerAs: '$ctrl',
                    controller: function () {
                        return ctrl;
                    }
                });
            };

            ctrl.cerrarModal = function () {
                $mdDialog.destroy();
                $state.go('ciudadano.misturnos');
            };

            ctrl.ImprimirComprobante = function (Id_Turno) {
                ctrl.turnoSeleccionado = null;
                $window.open('#!/reimprimir?Id_Turno=' + Id_Turno, '_blank');
                ctrl.cerrarModal();
            };

        }],
    template: require('./turnoOnlineConfirmacion.html')
});



// WEBPACK FOOTER //
// ./app/components/turnos/turnosOnline/turnoOnlineConfirmacionComponent.js